import { HCAPTCHA_TOKEN_MAX_STALENESS_SECONDS } from "@faire/web-api/indigofair/settings/HCAPTCHA_TOKEN_MAX_STALENESS_SECONDS";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingHCaptchaTokenStaleTimeS = (): number =>
  getSettingValueWithoutAssignment(HCAPTCHA_TOKEN_MAX_STALENESS_SECONDS, 110);
